export const ACTIONS:any = {
	DELETE: `delete`,
	VIEW: 'view_service'
}